import React, { useContext } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../Contexts/AuthContext/AuthProvider';

function getCookie(name) {
  const cookieValue = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
  return cookieValue ? cookieValue.pop() : '';
}

const AdminPrivateRoute = ({ children }) => {

    // const { authUser, token, isLoading} = useContext(AuthContext);
    const location = useLocation();
    // const [data, setData] = useState([]);
    // const [loading, setLoading] = useState(true);

    // useEffect(() => {
    //     const fetchUser = async () => {
    //         try {
    //             const res = await fetch(
    //                 `https://api.wlfmobile.com/api/admin/auth/view/${authId?._id}?deviceId=${authId?.deviceId}`,
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${token}`,
    //                     },
    //                 }
    //             );

    //             const data = await res.json();


    //             if (data) {
    //                 setData(data.success);
    //                 setLoading(false);
    //             }

    //         } catch (err) {
    //             // console.log(err)
    //         }
    //     };
    //     fetchUser();

    // }, [authId]);

    // if (isLoading) {
    //     return <></>;
    // }

     const [token, setToken] = useState(getCookie('WLF_Mobile_admin_token'));

    if (!token) {
        return <Navigate to='/' sate={{ from: location }} replace ></Navigate>

    } else {
        if (token) {
            return children;
        } else {
            <Navigate to='*' sate={{ from: location }} replace></Navigate>
        }
    }



}

export default AdminPrivateRoute;